exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dueDateInfoIcon---3Y13v {\n  display: block;\n  pointer-events: none;\n  width: 17px;\n  height: 17px;\n  background: transparent !important; }\n  .dueDateInfoIcon---3Y13v > span {\n    background: transparent; }\n  .dueDateInfoIcon---3Y13v > span > svg {\n      background: transparent; }\n", ""]);

// exports
exports.locals = {
	"dueDateInfoIcon": "dueDateInfoIcon---3Y13v"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/current-assignment-modal/assign-list/assignment/components/due-date-info/components/due-date-info-icon.scss
// module id = ISnF
// module chunks = 1